import { render, staticRenderFns } from "./VideoTagSelect.vue?vue&type=template&id=683857a0&scoped=true"
import script from "./VideoTagSelect.vue?vue&type=script&lang=js"
export * from "./VideoTagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683857a0",
  null
  
)

export default component.exports